'use client';

import { Button, MenuContent, MenuItem, MenuRoot, MenuTrigger } from '@/components/ui';
import { Box, Container, Flex, MenuPositioner, Portal, Text, Image } from '@chakra-ui/react';
import Link from 'next/link';
import React from 'react';
import { Header_menus } from './constant';
import { headerStyles } from './header.styles';
import { useAuthState } from '@/app/_providers/store';
import HeaderDropdown from './HeaderDropdown';
import useAuthFunc from '@/hooks/auth/useAuthFunc';
import config from '@/shared/config';

export default function Header() {
   const { isAuthenticated, user } = useAuthState();
   const { refreshSession } = useAuthFunc();

   React.useEffect(() => {
      refreshSession();
   }, [refreshSession]);

   return (
      <Container css={headerStyles.container} as="header">
         <Flex css={headerStyles.nav} as="nav">
            <Link href={config.WP_URL}>
               <Box css={headerStyles.imageBox}>
                  <Image src={'/assets/images/logo.svg'} alt="Logo" width="100" height="100" />
               </Box>
            </Link>
            <Box>
               <MenuRoot positioning={{ placement: 'bottom' }}>
                  <MenuTrigger asChild css={headerStyles.menuRoot}>
                     <Button focusRing="none">
                        <Flex align="center" gap="1.5" direction="column" className="bar">
                           <Box h="1px" w="8" bg="black" className="barLine_1" />
                           <Box h="1px" w="8" bg="black" className="barLine_2" />
                        </Flex>
                     </Button>
                  </MenuTrigger>
                  <Portal>
                     <MenuPositioner>
                        <MenuContent css={headerStyles.menuContent}>
                           {Header_menus.map(item => (
                              <MenuItem key={item.label} value={item.label} css={headerStyles.menuItem}>
                                 <Link style={{ outline: 'none', width: '100%' }} passHref href={item.href}>
                                    <Text>{item.label}</Text>
                                 </Link>
                              </MenuItem>
                           ))}
                        </MenuContent>
                     </MenuPositioner>
                  </Portal>
               </MenuRoot>
            </Box>
            {isAuthenticated ? (
               <HeaderDropdown user={user!} />
            ) : (
               <Link href="/auth/login">
                  <Button css={headerStyles.header_login_btn}>Login</Button>
               </Link>
            )}
         </Flex>
      </Container>
   );
}
